/* global femcare */

femcare.shared.inputs = {

    init: function () {
        if ($('form').length) {
            this.initDropdownPlaceholders();
            this.initAutoHeightTextarea();
            this.initTextareaCharacterCount();
            this.initSingleFieldDates();
            this.initMultiFieldDates();
            this.initMultipleChoiceInputs();
            this.initSubmitConsent();
            this.initCheckboxGroupSingleSelect();
            this.initInputTooltip();
            this.initSelectMenus();
            this.initCustomRadioOptions();
            this.initCustomSelectOptions();
        }
    },

    initInputsForForm: function ($form) {
        this.initDropdownPlaceholders($form);
        this.initAutoHeightTextarea($form);
        this.initTextareaCharacterCount($form);
        this.initSingleFieldDates($form);
        this.initMultiFieldDates($form);
        this.initMultipleChoiceInputs();
        this.initSubmitConsent($form);
        this.initCheckboxGroupSingleSelect($form);
        this.initInputTooltip($form);
        this.initSelectMenus($form);
        this.initCustomRadioOptions($form);
        this.initCustomSelectOptions($form);
    },

    initSingleFieldDates: function ($container) {
        var $datepickerElements = ($container || $('body')).find('.form-group--single-field-date');

        if ($datepickerElements.length) {

            var datepickerLoaded = !!$.fn.datepicker;

            if (datepickerLoaded) {
                instantiateSingleFieldDates();
            } else {
                var assetsPath = femcare.shared.util.getAssetsPath();
                $.getScript(assetsPath + '/js/datepicker.js', function () {
                    var localization = $('body').attr('data-google-language-code');
                    $.datepicker.setDefaults($.datepicker.regional[(localization || 'en')]);

                    instantiateSingleFieldDates();
                });
            }

            function instantiateSingleFieldDates() {
                $datepickerElements.each(function () {
                    $(this).singleFieldDate();
                });
            }
        }
    },

    /**
     * Init date widgets.
     * @param {object} $container jQuery object within which date widgets are to be initialized.
     */
    initMultiFieldDates: function ($container) {
        ($container || $('body')).find('.form-multi-field-date').each(function () {
            $(this).multiFieldDate({
                format: $(this).attr('data-format')
            });
        });
    },

    /**
     * Init multiChoice widgets.
     * @param {object} $container jQuery object within which multi choice widgets are to be initialized.
     */
    initMultipleChoiceInputs: function ($container) {
        ($container || $('body')).find('.form-group--multiple-choice-checkbox').each(function () {
            $(this).multiChoice();
        });
    },

    /**
     * Init selectmenu widgets.
     * @param {object} $container jQuery object within which selectmenu are to be initialized.
     */
    initSelectMenus: function ($container) {
        ($container || $('body')).find('.form-group--selectmenu').each(function () {
            var $select = $(this).find('select');
            var selectedOption = $select.find('option[selected]').val();
            $select.val(selectedOption);

            $(this).find('select').selectmenu({
                icons: { button: 'icon-arrow-down-smooth' }
            });
        });
    },

    initSubmitConsent: function ($container) {
        $container = $container || $('body form');

        var $allForms = $container.find('form').addBack('form');

        var termsCheckboxClass = '.termsCheckbox';
        var consentCheckboxSelector = '.consentCheckbox';

        $.each($allForms, function (index, form) {
            var $form = $(form);
            var $termsCheckboxes = $form.find(termsCheckboxClass);
            var $consentFields = $form.find(consentCheckboxSelector);
            
            var hasTermsCheckbox = $termsCheckboxes.length;
            var hasConsentFields = !hasTermsCheckbox && $consentFields.length;

            if (hasTermsCheckbox) {
                this.initAcceptTermsCheckbox($form, $termsCheckboxes);
            } else if (hasConsentFields) {
                this.initConsentCheckboxes($form, $consentFields);
            } else {
                // No consent needed so free to submit

                var $submit = $form.find('button[type="submit"]');
                if ($submit.length) {
                    $submit.prop('disabled', false);
                }
            }
        }.bind(this));
    },

    initAcceptTermsCheckbox: function ($form, $checkboxes) {
        if ($checkboxes.length) {

            var $submitButton = $form.find('button[type="submit"]');
            $submitButton.prop('disabled', true);

            // Must check to enable submission
            $checkboxes.on('click', function (e) {
                var $checkbox = $(this);

                if ($checkbox.is(':checked')) {
                    $submitButton.prop('disabled', false);
                } else {
                    $submitButton.attr('disabled', 'true');
                }
                e.stopPropagation();
            });

            // Prevent checkbox click when link within label clicked
            $checkboxes.next('label').find('a').on('click', function (e) {
                e.stopPropagation();
            });

            // Disable submit and uncheck on error
            $form.on('inputsInvalid recaptchaInvalid', function () {
                if ($checkboxes.length) {
                    $checkboxes.prop('checked', false);
                    $submitButton.prop('disabled', true);
                }
            });
        }
    },

    initConsentCheckboxes: function ($form, $checkboxes) {
        if ($checkboxes.length) {

            var $submitButton = $form.find('button[type="submit"]');
            $submitButton.prop('disabled', true);

            // Toggle enable/disable on consent given
            $checkboxes.on('click', function (e) {
                var consentGiven = $checkboxes.filter(':checked').length > 0;
                $submitButton.prop('disabled', !consentGiven);
                e.stopPropagation();
            });

            // Disable submit when form invalid.
            $form.on('inputsInvalid recaptchaInvalid', function () {
                $checkboxes.prop('checked', false);
                $submitButton.prop('disabled', true);
            });

            // Prevent checkbox click when link within label clicked.
            $checkboxes.next('label').find('a').on('click', function (e) {
                e.stopPropagation();
            });
        }
    },

    /**
     * Init select input placeholders.
     * @param {object} $container jQuery object within which dropdowns are to be initialized.
     */
    initDropdownPlaceholders: function ($container) {
        var $dropdownsWithPlaceholder = ($container || $('body')).find(
            'select.select--placeholder'
        );

        $dropdownsWithPlaceholder.on('change', function removePlaceholder() {
            var $dropdown = $(this);
            $dropdown.removeClass('select--placeholder');
            $dropdown.off('change', removePlaceholder);
        });
    },

    /**
     * Init auto height textarea.
     * @param {object} $container jQuery object within which textareas are to be initialized.
     */
    initAutoHeightTextarea: function ($container) {
        ($container || $('body'))
            .find('textarea')
            .each(function () {
                $(this).attr(
                    'style',
                    'height:' + this.scrollHeight + 'px;overflow-y:hidden;'
                );
                if (!$(this).attr('maxlength')) {
                    $(this).attr('maxlength', 2000);
                }
            })
            .on('input', function () {
                this.style.height = 'auto';
                this.style.height = this.scrollHeight + 'px';
            });
    },

    /**
     * Indit textarea char count indicator.
     * @param {object} $container jQuery object within which textareas are to be initialized.
     */
    initTextareaCharacterCount: function ($container) {
        var $textAreaWrappers = ($container || $('body')).find(
            '.textarea-char-count-wrapper'
        );

        $textAreaWrappers.find('textarea').on('change input', function () {
            var length = $(this).val().length;
            var maxLength = parseInt($(this).attr('maxlength'), 10);

            if (length <= maxLength) {
                var $count = $(this)
                    .parent('.textarea-char-count-wrapper')
                    .find('.counter');
                var remaining = maxLength - length;
                $count.text(remaining + ' / ' + maxLength);
            }
        });
    },

    /**
     * Make checkbox behavior be like radio buttons ( single select and cannot unselect ).
     * @param {object} $container jQuery object within which checkbox group is to be initialized.
     */

    initCheckboxGroupSingleSelect: function ($container) {
        var $checkboxGroups = ($container || $('body')).find(
            '.form-group--single-select-checkbox'
        );

        $checkboxGroups.find('input[type="checkbox"]').on('click', function () {
            $('[name="' + $(this).attr('name') + '"]').prop('checked', false);
            $(this).prop('checked', true);
        });
    },

    /**
     * Toggle tooltip on input hover.
     * @param {object} $container jQuery object within which input tooltips are to be initialized.
     */

    initInputTooltip: function ($container) {
        var $tooltips = $($container || $('body')).find('.form-control-tooltip');

        $.each($tooltips, function (index, tooltip) {
            var $tooltip = $(tooltip);
            var id = $tooltip.attr('data-control-id');
            var $input = $('#' + id);
            var $label = $('label[for="' + id + '"]');
            var timeout = null;

            $input.add($label).hover(
                function () {
                    timeout = setTimeout(function () {
                        $tooltip.fadeIn(300);
                    }, 500);
                },
                function () {
                    clearTimeout(timeout);
                    $tooltip.fadeOut(300);
                }
            );
        });
    },

    initCustomRadioOptions: function ($container) {
        var $customOptions = ($container || $('body')).find('.form-radio-control .form-group-custom-option');

        $customOptions.each(function (index, element) {
            var $customOption = $(element);
            var $customOptionInput = $customOption.find('input');

            var $parentRadioButtonGroup = $customOption.closest('.form-group');
            var $associatedRadioButton = $customOption.closest('.form-radio-control').find('input[type="radio"]');
            var $unassociatedRadioButtons = $parentRadioButtonGroup.find('input[type="radio"]').not($associatedRadioButton);

            $associatedRadioButton.on('click', function () {
                $customOption.show();
                $customOptionInput.resetInput();
                $customOptionInput.focus();
            });

            $unassociatedRadioButtons.on('click', function () {
                $customOption.hide();
                $customOptionInput.resetInput();
            });
        });
    },

    initCustomSelectOptions: function ($container) {
        var $customOptions = ($container || $('body')).find('.form-group select+.form-group-custom-option');

        $customOptions.each(function (index, element) {
            var $customOption = $(element);
            var $customOptionInput = $customOption.find('input');
            var $select = $customOption.prev('select');
            var $associatedOption = $select.find('option:last-child');

            $select.on('change', function () {
                if ($select.val() === $associatedOption.val()) {
                    $customOption.show();
                    $customOptionInput.resetInput();
                    $customOptionInput.focus();
                } else {
                    $customOption.hide();
                    $customOptionInput.resetInput();
                }
            })

        });
    }
};
